import { createSlice } from '@reduxjs/toolkit';
import * as AllAction from '../action';
import AllActionType from '../actionType';
import {
  makeFetchFailedActionType,
  makeFetchSuccessActionType,
} from '../../event/fetchActionTypeProvider';
const initialState: any = {
  timestamp: 0,
  total: 0,
  data: [],
};

const oprationState = createSlice({
  name: 'oprationLog',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      makeFetchSuccessActionType(AllActionType.OPERATION_RECORD),
      (state, action: any) => {
        const response = action.payload;
        if (response.errorCode != 0) {
          state.timestamp = Date.now();
          return;
        }
        state.timestamp = Date.now();
        state.total = response.data.total;
        state.data = response.data.list.map((item: any, index: number) => ({
          ...item,
          key: index,
        }));
      },
    );
    builder.addCase(
      AllAction.actionClearOperationList,
      (state, action: any) => {
        state.timestamp = 0;
        state.total = 0;
        state.data = [];
      },
    );
  },
});

export default oprationState.reducer;
